import logo from "./logo.svg";
import "./App.css";
import Routes from "./router/router";
import ToastNotification from "./components/ToastNotification";
import { useEffect, useState } from "react";

function App() {
  const [isLogin, setIsLogin] = useState(null);
  useEffect(() => {
    const user = localStorage.getItem("linko_admin");
    if (user) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, []);
  return (
    <>
      <ToastNotification />
      <Routes isLogin={isLogin} />
    </>
  );
}

export default App;
